import { OrderScreen } from '../features/orders/OrderScreen'
import { useShell } from '../app/outlet'

export function OrderPage() {
  const { toast } = useShell()
  return <OrderScreen onToast={toast} />
}
